<template>

    <form-group :validator="v" :label="label" :label-for="id" 
        :description="tip ? tip : 'Format: yyyy-MM-dd HH:mm'">
        <template slot-scope="{ attrs, listeners }">
            <date-picker :id="id" v-model="text" 
                v-bind="attrs"
                :state="v.$dirty ? !v.$error : null"
                v-on="listeners"
                :config="options"
                :data-test="slug"
                :required="!v.required">            
            </date-picker>
        </template>
    </form-group>
    
</template>

<script>
import _ from "lodash"
import datePicker from 'vue-bootstrap-datetimepicker';
import 'pc-bootstrap4-datetimepicker/build/css/bootstrap-datetimepicker.css';

export default {
    components: {
        datePicker,
    },
    props: {
        value: [String, Number],
        v: [Object],
        label: [String],
        tip: [String],
        slug: [String],
        required: [Boolean],
        plaintext: Boolean
    },
    data() {
        return {
            options: {
                format: 'YYYY-MM-DD hh:mm',
                useCurrent: false,
            }, 
        }
    },
    computed: {
        id() {
            return _.uniqueId('date')
        },
        text: {
            get() {
                return this.value;
            },
            set(value) {
                this.v.$touch();
                this.$emit("input", value);
            }
        }   
    }
}
</script>
<style>
.form-group > label {
    font-weight: 750;
}
</style>